import { Sentence } from 'interfaces/db/sentence'

function chunkSentence(sentence: string, maxLength: number): string[] {
  const chunks: string[] = []
  let currentChunk = ''

  sentence.split(' ').forEach((word) => {
    if ((currentChunk + word).length > maxLength) {
      chunks.push(currentChunk.trim())
      currentChunk = word
    } else {
      // Check if currentChunk is empty to avoid extra space at the beginning
      currentChunk += currentChunk.length > 0 ? ' ' + word : word
    }
  })

  if (currentChunk.length > 0) {
    chunks.push(currentChunk.trim())
  }

  return chunks
}

export function textSegmentation(sentences: Sentence[]): Sentence[] {
  const maxLength = 90
  const newSentences: Sentence[] = []

  sentences.forEach((sentence) => {
    const chunks = chunkSentence(sentence.text, maxLength)

    if (chunks.length > 1) {
      let startWordIndex = 0

      chunks.forEach((chunk, i) => {
        let endWordIndex = startWordIndex + chunk.split(' ').length - 1
        endWordIndex = Math.min(endWordIndex, sentence.words.length - 1)

        const start = sentence.words[startWordIndex]?.start ?? 0 // Fallback to 0 if undefined
        const end = sentence.words[endWordIndex]?.end ?? 0 // Fallback to 0 if undefined

        const newSentence: Sentence = {
          ...sentence,
          text: chunk,
          start: start,
          end: end,
          words: sentence.words.slice(startWordIndex, endWordIndex + 1),
        }

        newSentences.push(newSentence)
        startWordIndex = endWordIndex + 1
      })
    } else {
      newSentences.push(sentence)
    }
  })

  return newSentences
}
